import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UiHelper } from '@helpers/ui.helper';
import { LocalizationService } from '@services/localization.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@services/translate.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DataHelper } from '@helpers/data.helper';
import { UserHelper } from '@helpers/user.helper';
import { sportsSvgList } from '@app/constants/svgUrl.constant';
import { LiveStreamService } from '@services/liveStream.service';
import debounce from 'lodash/debounce';

@Component({
  selector: 'story-slider',
  templateUrl: '../sharedTemplates/story.slider.component.html',
})
export class StorySliderComponent {
  public sportsSvgList = sportsSvgList;
  listArray = [];
  totalCount = 0;
  _SelectedItem = this._TranslateService.instant('Soccer');
  SelectedSportId = 1;
  isMobileView = false;
  @Input() liveSide = '';
  @Output() clickedItem = new EventEmitter<any>();
  @Input()
  slideShowTime = 2;
  filterItemCount;

  @Input()
  set filterItem(e) {
    if (e) {
      this.filterItemCount = e.length;
    }
  }

  @Input()
  set slideShow(e) {
    if (e) {
      this.slideShowSetter();
    }
  }
  elementData = this._DataHelper.storySportsData;

  @Input()
  set data(e) {
    if (e && e != undefined && e.length > 0) {
      this.listArray = [];
      if (this.elementData && this.elementData != undefined && this.elementData.length > 0) {
        e.forEach((x, index1) => {
          this.elementData.forEach((y, index2) => {
            if (y.SportName == x.key1) {
              const _data = {
                imageUrl: y.imageUrl,
                pngUrl: y.pngUrl,
                sportName: x.key2,
                count: x.count,
                sportId: x.sportId,
                selected: this.SelectedSportId == x.sportId ? true : false,
                sportNameOrginal: y.SportName,
              };
              this.listArray.push(_data);
              if (_data.selected == true) {
                this._DataHelper.selectedStoryItem = _data;
                this.SelectedSportId = x.sportId;
                this._SelectedItem = x.key2;
              }
            }
          });
        });

        this.listArray.splice(this.listArray.length, 0, {
          imageUrl: 'all.svg',
          pngUrl: 'all.svg',
          sportName: this._TranslateService.instant('all'),
          selected: false,
          sportId: -1,
          sportNameOrginal: 'all',
          count: this.totalCount,
        });
        // //console.log('this.listArray',this.listArray)

        this.clickedItem.emit({ sportName: this._SelectedItem, sportId: this.SelectedSportId });
      } else {
        this.listArray = e;
      }
    }
    this.calculateTotalCount();
  }

  constructor(
    private _UiHelper: UiHelper,
    public _LZ: LocalizationService,
    public _Router: Router,
    private _ActivatedRoute: ActivatedRoute,
    public _LocalizationService: LocalizationService,
    private _BottomSheet: MatBottomSheet,
    public _DataHelper: DataHelper,
    public _UserHelper: UserHelper,
    public _LiveStreamService: LiveStreamService,
    private _TranslateService: TranslateService
  ) {
    if (this._DataHelper.selectedStoryItem != undefined) {
      // 03-02-2022 de kapatıldı. Ice Hockey ve Table Tennis te  maç detayına gidip tekrar Live a dönünce Seçilen Spor bozuluyordu.
      // Default olarak Tennis e veya Soccer a gidiyordu
      // this._SelectedItem=this.this._TranslateService.instant(`${this._DataHelper.selectedStoryItem.sportNameOrginal}`, null);

      if (this._DataHelper.selectedStoryItem != undefined) {
        this._SelectedItem = this._DataHelper.selectedStoryItem.sportName;
        this.SelectedSportId = this._DataHelper.selectedStoryItem.sportId;
      }
    }
    this._UiHelper.windowsWidth < 990 ? (this.isMobileView = true) : (this.isMobileView = false);
    this._UiHelper.windowResized.subscribe(x => {
      if (x.w <= 990) {
        this.isMobileView = true;
      } else {
        this.isMobileView = false;
      }
    });
  }
  flag = false;
  calculateTotalCount() {
    if (!this.flag && this.listArray.length > 0) {
      this.totalCount = this.listArray.reduce((sum, item) => sum + (item.count || 0), 0);
      this.flag = true;
    }
  }
  liveMatchFilterAction = debounce(
    (selection: 'time' | 'league'): void => {
      this._DataHelper.liveMatchFilter = selection;
      this._DataHelper.liveMatchFilterListener.emit(selection);
    },
    1000,
    { leading: true }
  );
  mySlipButtonAction(x: boolean): void {
    this._DataHelper.liveHeaderTitle = this._TranslateService.instant('my_bets');
    this._DataHelper.setFavoritesButtonStatus(false);
    this._LiveStreamService.setIsOnTvButton(false);
    this._DataHelper.setIsMySlipButton(x);
  }

  onTvButtonAction(x: boolean): void {
    this._DataHelper.liveHeaderTitle = this._TranslateService.instant('On_Tv');
    this._DataHelper.setFavoritesButtonStatus(false);
    this._DataHelper.setIsMySlipButton(false);
    this._LiveStreamService.setIsOnTvButton(x);
  }

  selectStoryItem(e) {
    localStorage.setItem('league-filter-data', JSON.stringify([]));

    this.listArray = this.listArray.map(x => {
      if (x != undefined && x.sportName == e) {
        x.selected = true;
        this.SelectedSportId = x.sportId;

        this._SelectedItem = x.sportName;
      } else {
        x.selected = false;
      }
      return x;
    });
    // this.clickedItem.emit(e);
    this.clickedItem.emit({ sportName: e, sportId: this.SelectedSportId });
    this._DataHelper.setFavoritesButtonStatus(false);
  }

  selectStoryItemForp1001(e) {
    this.mySlipButtonAction(false);
    this.onTvButtonAction(false);
    this._DataHelper.selectedStoryItem = e;
    this._DataHelper.liveHeaderTitle = e?.sportName;
    //Yapı düzgün çalışsın diye manuel setlendi comboOdd lar değişince kurgu değişecek
    this._DataHelper.comboSelectedOdd = { OddId: 0, OddNameLong: 'tipp_long', OddNameLong2: '', OddName: 'tipp', OddTitles: ['1', 'X', '2'] };

    // League Filter Clean ( Local Storage )
    localStorage.setItem('league-filter-data', JSON.stringify([]));

    // //console.log('selectStoryItem',e);
    this.listArray = this.listArray.map(x => {
      if (x.sportName == e.sportName) {
        x.selected = true;
        this.SelectedSportId = x.sportId;
        // console.log('--SelectedSportId--',x.sportId)
        //console.log('--sportID--',this.SelectedSportId)
        this._SelectedItem = x.sportName;
      } else {
        x.selected = false;
      }
      return x;
    });
    // this.clickedItem.emit(e);
    this.clickedItem.emit({ sportName: e.sportName, sportId: this.SelectedSportId });
    this._DataHelper.setFavoritesButtonStatus(false);
  }

  slideShowSetter() {
    setInterval(() => {
      /*
          if (this.selectedListItem != this.listArraySize) {
            this.changeSlider(this.selectedListItem + 1);
          } else {
            this.changeSlider(1);
          }
  */
    }, this.slideShowTime * 1000);
  }
}
